import type { ZoneCountry } from '@/types/api';

// Mixpanel event names for the hunting-zones feature. Centralised
// here so every emit site references the same string constant — drift
// between caller and dashboard is the most common analytics bug.

export const ZONES_MIXPANEL_EVENTS = {
  /** Admin clicked "Sync from Notion". */
  SYNC_TRIGGERED: 'zones_sync_triggered',
  /** A sync job reached `completed`. */
  SYNC_COMPLETED: 'zones_sync_completed',
  /** A sync job reached `failed` (or the trigger call errored). */
  SYNC_FAILED: 'zones_sync_failed',
  /** A Zone Management row opened the zone on the map. */
  ROW_OPENED: 'zone_row_opened',
  /** The Zone Management filter selection settled (debounced). */
  FILTERS_APPLIED: 'zone_filters_applied',
} as const;

export type ZonesMixpanelEvent = (typeof ZONES_MIXPANEL_EVENTS)[keyof typeof ZONES_MIXPANEL_EVENTS];

// Per-event payload shape contracts. The runtime emit site validates
// nothing — these types are the contract.

export interface ZonesSyncTriggeredPayload {
  initiated_by_email?: string;
}

export interface ZonesSyncCompletedPayload {
  job_id: string;
  created: number;
  updated: number;
  skipped: number;
  failed: number;
  deleted: number;
}

export interface ZonesSyncFailedPayload {
  job_id?: string;
  failure_reason?: string;
}

export interface ZoneRowOpenedPayload {
  zone_id: string;
  country: ZoneCountry | null;
  has_owner: boolean;
}

/** The filter axes reported by FILTERS_APPLIED, in a fixed order. */
export const ZONE_FILTER_TRACKED_AXES = ['names', 'countries', 'owner_ids'] as const;

export type ZoneFilterTrackedAxis = (typeof ZONE_FILTER_TRACKED_AXES)[number];

export interface ZoneFiltersAppliedPayload {
  active_axes: ZoneFilterTrackedAxis[];
  axis_count: number;
  value_count: number;
  cleared: boolean;
}
